exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex[data-v-20482422] {\n    display: flex;\n    align-items: center;\n}\n.wupin-select[data-v-20482422] {\n    color: #515a6e;\n    font-size: 14px;\n    line-height: normal;\n    display: block;\n    box-sizing: border-box;\n    outline: none;\n    user-select: none;\n    cursor: pointer;\n    position: relative;\n    background-color: #fff;\n    border-radius: 4px;\n    border: 1px solid #dcdee2;\n    transition: all .2s ease-in-out;\n    height: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20482422","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/CustomTable.vue
// module id = xa0w
// module chunks = 142